import type { ServerMetadata } from "@app/lib/actions/mcp_internal_actions/tool_definition";
import { z } from "zod";

export const USER_MEMORY_SERVER_NAME = "user_memory" as const;
export const USER_MEMORY_EDIT_TOOL_NAME = "edit";

// The tool descriptions deliberately name the user's "MEMORY.md": pointing the
// model at a concrete markdown memory file is relatively industry-standard and
// reinforces the expected recall/update behavior, even though the file itself is
// an implementation detail on our end.
export const USER_MEMORY_TOOLS_METADATA = [
  {
    name: USER_MEMORY_EDIT_TOOL_NAME,
    description:
      "Update, change, correct, add, or delete text in the current user's personal memory by replacing an exact snippet of their MEMORY.md with new text.",
    schema: {
      oldStr: z
        .string()
        .describe(
          "The exact, contiguous text to find in the user's personal memory " +
            "and replace. It must match a unique span of the current memory. " +
            "Pass an empty string to initialize memory that is currently empty."
        ),
      newStr: z
        .string()
        .describe(
          "The replacement text. Pass an empty string to delete the matched text."
        ),
    },
    stake: "never_ask",
    displayLabels: {
      running: "Editing memory",
      done: "Edit memory",
    },
    toolCostCategory: "basic",
    freeUsage: true,
  },
] as const;

export const USER_MEMORY_SERVER = {
  serverInfo: {
    name: USER_MEMORY_SERVER_NAME,
    version: "1.0.0",
    description:
      "Store and retrieve the current user's personal memory, shared across the user's agents.",
    authorization: null,
    icon: "ActionLightbulbIcon",
    documentationUrl: null,
  },
  tools: USER_MEMORY_TOOLS_METADATA,
} as const satisfies ServerMetadata;
